import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const HondurasFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14939'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14939)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#0884E6'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#0884E6'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99926 7.46665L9.32582 7.65995L9.52307 6.99998L9.32582 6.34002L9.99926 6.53332L10.6727 6.34002L10.4754 6.99998L10.6727 7.65995L9.99926 7.46665Z'
					fill='#0E88E9'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.8098 6.5333L13.1364 6.7266L13.3336 6.06663L13.1364 5.40667L13.8098 5.59997L14.4832 5.40667L14.286 6.06663L14.4832 6.7266L13.8098 6.5333Z'
					fill='#0E88E9'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.8098 8.4L13.1364 8.5933L13.3336 7.93333L13.1364 7.27337L13.8098 7.46667L14.4832 7.27337L14.286 7.93333L14.4832 8.5933L13.8098 8.4Z'
					fill='#0E88E9'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.19066 8.4L5.51723 8.5933L5.71447 7.93333L5.51723 7.27337L6.19066 7.46667L6.8641 7.27337L6.66685 7.93333L6.8641 8.5933L6.19066 8.4Z'
					fill='#0E88E9'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.19066 6.5333L5.51723 6.7266L5.71447 6.06663L5.51723 5.40667L6.19066 5.59997L6.8641 5.40667L6.66685 6.06663L6.8641 6.7266L6.19066 6.5333Z'
					fill='#0E88E9'
				/>
			</g>
		</svg>
	);
};

export default HondurasFlagIcon;
